// 首页
<template>
  <div class="home" :style="rootVars">
    <ul class="flx-cc list">
      <li><a class="inter" href="/#/international">{{ $C('index','linkInternational','国际市场') }}</a></li>
      <li><a class="china" href="/#/china">{{ $C('index','linkChina','国内市场') }}</a></li>
      <li><a class="ganzi" href="/#/ganzi">{{ $C('index','linkGanzi','甘孜市场') }}</a></li>
    </ul>
      <div class="lottie">
          <LottieAnimation :animationData="myAnimation" />
      </div>
  </div>
</template>

<script>
import LottieAnimation from '../common/LottieAnimation.vue';
import myAnimation from '../../../public/assets/data_loop.json'; // 替换为你的 JSON 路径
import { mediaUrl } from '@/cms/config'

export default {
  name: '',
  components: {LottieAnimation},
  data() {
    return {
      myAnimation
    };
  },
  computed: {
    rootVars() {
      const bg = this.$C('index', 'pageBg', '')
      return bg ? { background: `url("${mediaUrl(bg)}") center/cover no-repeat #061634` } : {}
    },
  },
  methods: {
  },
};
</script>
<style lang="less" scoped>
@import '@/styles/index';
</style>